import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { TaskFieldSidebarListItemLayout } from "../../TaskFieldSidebarListItemLayout";
import { ReactComponent as AddIcon } from "../assets/add.svg";

interface AddNewValueButtonProps {
  onClick: () => void;
}

export const AddNewValueButton: FC<AddNewValueButtonProps> = ({ onClick }) => {
  const { t } = useTranslations();

  return (
    <TaskFieldSidebarListItemLayout.Root
      startSlot={<AddIcon />}
      onClick={onClick}
    >
      <TaskFieldSidebarListItemLayout.Label className="text-dark-500">
        {t({
          id: "tasks-page.add-new-value",
          defaultMessage: "Add new value",
        })}
      </TaskFieldSidebarListItemLayout.Label>
    </TaskFieldSidebarListItemLayout.Root>
  );
};
